// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2dhYu","content":"styles_content__1LQIc","selectAll":"styles_selectAll__1qyTz"};